function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "peopleViewingIcon");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Assets",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Kontomo-assets",
  transform: "translate(-381.000000, -748.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "peopleViewingIcon",
  transform: "translate(380.000000, 744.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(1.000000, 4.000000)",
  fill: "#EF4E23"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.67,9.13 C17.04,10.06 18,11.32 18,13 L18,16 L22,16 L22,13 C22,10.82 18.43,9.53 15.67,9.13 L15.67,9.13 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fillRule: "nonzero",
  cx: 8,
  cy: 4,
  r: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M14,8 C16.21,8 18,6.21 18,4 C18,1.79 16.21,0 14,0 C13.53,0 13.09,0.1 12.67,0.24 C13.5,1.27 14,2.58 14,4 C14,5.42 13.5,6.73 12.67,7.76 C13.09,7.9 13.53,8 14,8 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8,9 C5.33,9 0,10.34 0,13 L0,16 L16,16 L16,13 C16,10.34 10.67,9 8,9 Z",
  id: "Path"
})))));

var SvgPeopleViewingIcon = function SvgPeopleViewingIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "16px",
    viewBox: "0 0 22 16",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPeopleViewingIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/peopleViewingIcon.dfc375d8.svg";
export { ForwardRef as ReactComponent };